/* eslint-disable react/prop-types */
import React from 'react';
import Context from './context';
export default class GlobalState extends React.Component {
    state = {
        _step: 1,
    };

    setStep = (step: any) => {
        this.setState({ _step: step });
    };

    render() {
        return (
            <Context.Provider
                value={{
                    _step: this.state._step,
                    setStep: this.setStep,
                }}
            >
                {this.props.children}
            </Context.Provider>
        );
    }
}
